import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, Stack, Typography } from '@mui/material';
import Loader from 'components/Loader';
import { SlideTileGenerationStatus } from 'interfaces/tileGeneration';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { getTileGenerationPresentation } from './tileGenerationPresentation';

interface TileGenerationStatusLineProps {
  status: SlideTileGenerationStatus;
  jobUrl: string | null;
}

const TileGenerationStatusLine = ({ status, jobUrl }: TileGenerationStatusLineProps) => {
  const { state, text, percent } = getTileGenerationPresentation(status);
  const content =
    state === 'active' ? (
      <Loader inline message={`Tiles: ${text}`} value={percent} testId="tile-generation-status" />
    ) : (
      <Typography
        variant="caption"
        color={state === 'failed' ? 'error' : 'text.secondary'}
        data-testid="tile-generation-status"
      >
        {text}
      </Typography>
    );

  if (!jobUrl) {
    return content;
  }
  return (
    <Link
      component={RouterLink}
      to={jobUrl}
      underline="none"
      color="inherit"
      aria-label={`Open tile generation job: ${text}`}
      sx={{ display: 'inline-flex', minWidth: 0 }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 0 }}>
        {content}
        <OpenInNewIcon color="action" sx={{ fontSize: 16 }} />
      </Stack>
    </Link>
  );
};

export default TileGenerationStatusLine;
